<!-- Spinner -->

<!-- Chapter -->
<ng-template #chapter_template let-media="media">
  <img [src]="mediaControlService.getUrl(media)"
    [alt]="media.altText" />
  @if (media.mediaCopyrights.length > 0) {
    <figcaption>
      @for (mediaCopyright of media.mediaCopyrights; track mediaCopyright.id) {
        @if (appSharedFacade.copyright$(mediaCopyright.copyright) | async; as copyright) {
          <span>{{ copyright.text }} {{ mediaCopyright.text }}</span><br>
        }
      }
    </figcaption>
  }
</ng-template>

<!-- Content -->
@if ((nodeSharedFacade.currentSelectedNode$ | async); as node) {
  <div class="mdsf-text scrollable editor-input"
    >
    @if ((appSharedFacade.page$(node.page) | async); as page) {
      <div class="text-container"
        #textElement>
        <medsurf-text-format [text]="formatDescription(page.body, (appSharedFacade.themeColor$ | async))"></medsurf-text-format>
      </div>
      @if (page && (appSharedFacade.media$(page.media) | async); as media) {
        <figure
          class="image d-none d-md-block">
          <ng-container *ngTemplateOutlet="chapter_template;context:{media: media}"></ng-container>
        </figure>
      }
    } @else {
      <div class="d-flex justify-content-center m-2">
        <div class="spinner-border"></div>
      </div>
    }
  </div>
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}

